/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../queryTyping';

import { gql } from '@apollo/client';
export type RecurringOptionFieldsFragment = (
  { __typename?: 'RecurringOption' }
  & Pick<Types.RecurringOption, 'id' | 'displayName' | 'isSecondStartDateSupported' | 'canModifyAmount' | 'isStartDateSupported' | 'isEndDateSupported' | 'isEndAfterCountSupported' | 'arePaymentOptionsSupported'>
);

export const RecurringOptionFieldsFragmentDoc = gql`
    fragment RecurringOptionFields on RecurringOption {
  id
  displayName
  isSecondStartDateSupported
  canModifyAmount
  isStartDateSupported
  isEndDateSupported
  isEndAfterCountSupported
  arePaymentOptionsSupported
}
    `;